import { StakeAccountLayout, } from "../structs/StakeAccountData";
export const stakeAccountParser = (raw) => {
    const pubkey = raw.pubkey;
    const buffer = Buffer.from(raw.account.data);
    const data = StakeAccountLayout.decode(buffer);
    return { pubkey, data };
};
//# sourceMappingURL=StakeAccountParser.js.map